import React, { useState } from 'react';
import IssueVoucherForm from './IssueVoucherForm';
import QuickRedeemPad from './QuickRedeemPad';
import VoucherAdjustForm from './VoucherAdjustForm';
import VoucherHistoryModal from './VoucherHistoryModal';
import EditClientModal from '../../clients/components/EditClientModal';
import { hydrateIssueMovementTimes } from '../utils/voucherMovements';
import { pickBestDateTime } from '../utils/voucherDates';

export default function VoucherCustomerCard({
  customer,
  onIssueVoucher,
  onRedeemVoucher,
  onAdjustVoucher,
  onLoadMovements,
  onRefresh,
  busyVoucherId,
  actor,
}) {
  const [historyState, setHistoryState] = useState({ voucherCode: '', movements: [], open: false });
  const [historyError, setHistoryError] = useState('');
  const [editModalOpen, setEditModalOpen] = useState(false);

  async function handleOpenHistory(voucher) {
    setHistoryError('');

    try {
      const movementsResponse = await onLoadMovements(voucher.id);
      setHistoryState({
        voucherCode: voucher.voucherCode,
        movements: hydrateIssueMovementTimes(
          movementsResponse.items || [],
          pickBestDateTime(voucher.purchaseDate, voucher.createdAt),
        ),
        open: true,
      });
    } catch (_error) {
      setHistoryError('No se pudo cargar el historial rápido de este bono.');
    }
  }

  return (
    <>
      <article className="rounded-[30px] border border-[var(--app-border)] bg-[var(--app-surface)] p-6 space-y-5 shadow-[0_24px_60px_rgba(15,23,42,0.05)] backdrop-blur-xl">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="flex-1">
            <div className="flex items-center gap-3">
              <h3 className="text-[34px] leading-none font-semibold tracking-[-0.04em] text-slate-950">{customer.fullName}</h3>
              <button
                type="button"
                onClick={() => setEditModalOpen(true)}
                className="rounded-full bg-slate-100 p-2 text-slate-500 hover:bg-slate-200 hover:text-blue-600 transition"
                title="Editar datos del cliente"
              >
                ✎
              </button>
            </div>
            <p className="text-slate-500 mt-2">{customer.phone} {customer.email ? `· ${customer.email}` : ''}</p>
          </div>
          <div className="rounded-[24px] border border-[rgba(0,113,227,0.12)] bg-[rgba(0,113,227,0.08)] px-5 py-4 text-center min-w-[190px]">
            <p className="text-[11px] uppercase tracking-[0.18em] text-[var(--app-accent)]">Saldo total</p>
            <p className="text-4xl font-semibold tracking-[-0.04em] text-slate-950">{customer.hoursAvailable}h</p>
          </div>
        </div>

        {onIssueVoucher && (
          <IssueVoucherForm
            customer={customer}
            onIssue={onIssueVoucher}
            busy={busyVoucherId === `issue-${customer.id}`}
            actor={actor}
          />
        )}

        <div className="space-y-4">
          {historyError && (
            <p className="text-sm font-medium text-red-600">{historyError}</p>
          )}
          {customer.vouchers.length === 0 ? (
            <p className="text-slate-500">Esta persona todavía no tiene bonos registrados.</p>
          ) : (
            <>
              <p className="text-sm font-medium text-slate-700">Bonos de la persona</p>
              {customer.vouchers.map((voucher) => (
                <div key={voucher.id} className="space-y-3">
                  <QuickRedeemPad
                    voucher={voucher}
                    busy={busyVoucherId === voucher.id}
                    onRedeem={(hours) => onRedeemVoucher(voucher, hours, customer.phone)}
                    onOpenHistory={() => handleOpenHistory(voucher)}
                  />
                  {onAdjustVoucher && (
                    <VoucherAdjustForm
                      voucher={voucher}
                      busy={busyVoucherId === voucher.id}
                      onAdjust={(payload) => onAdjustVoucher(voucher, payload, customer.phone)}
                    />
                  )}
                </div>
              ))}
            </>
          )}
        </div>
      </article>

      {historyState.open && (
        <VoucherHistoryModal
          voucherCode={historyState.voucherCode}
          movements={historyState.movements}
          onClose={() => setHistoryState({ voucherCode: '', movements: [], open: false })}
        />
      )}

      {editModalOpen && (
        <EditClientModal
          customer={customer}
          actor={actor}
          onClose={() => setEditModalOpen(false)}
          onSave={(updatedCustomer) => {
            setEditModalOpen(false);
            if (onRefresh) onRefresh();
          }}
        />
      )}
    </>
  );
}
